import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_CLUB, ROUTE_CLUBS, ROUTE_MEMBER, ROUTE_PIGEON_HOLE} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";
import {replace} from "react-router-redux";

import {NotificationManager} from "react-notifications";

import PigeonHoleGeneral from "./subPages/PigeonHoleGeneral";
import PigeonHolePigeons from "./subPages/PigeonHolePigeons";
import PigeonHoleVaccination from "./subPages/PigeonHoleVaccination";
import {defaultState as generalProps} from "./subPages/PigeonHoleGeneral";

import {hasCommonProps} from "../../../utils/Util";

class PigeonHolePage extends React.Component {

    static getId() {
        return ROUTE_PIGEON_HOLE;
    }

    static getAllowedRoles() {
        return [UserRoles.CLUB_ADMIN, UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadPigeonHole(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.clubNo !== this.props.params.clubNo || nextProps.params.holeNo !== this.props.params.holeNo) this.loadPigeonHole(nextProps);
    }

    loadPigeonHole = newestProps => {
        const club = newestProps.admin.clubs ? newestProps.admin.clubs.get(newestProps.params.clubNo) || null : null;
        if (club === null || typeof(club.isFullLoaded) === 'undefined') newestProps.dispatch(AdminActions.getClub(newestProps.params.clubNo));
        if (!newestProps.params.holeNo.toLowerCase().startsWith('new')) newestProps.dispatch(AdminActions.getPigeonHole(newestProps.params.clubNo, newestProps.params.holeNo));
    };

    render() {
        const clubNo = this.props.params.clubNo;
        const club = clubNo.toLowerCase() === 'new' || !this.props.admin.clubs ? null : this.props.admin.clubs.get(clubNo) || null;
        const holeNo = this.props.params.holeNo.toLowerCase().startsWith('new') ? this.props.params.holeNo.substring(3) : this.props.params.holeNo;
        let hole = holeNo === '' ? null : (this.props.params.holeNo.toLowerCase().startsWith('new') ? (club === null ? null : club.UpdateRequests.find(req => req.type === 'pigeonhole' && req.newKey === holeNo) || null) : (!this.props.admin.pigeonHoles ? null : this.props.admin.pigeonHoles.get(clubNo + '-' + holeNo) || null));
        if (this.props.params.holeNo.toLowerCase().startsWith('new') && hole !== null) hole = JSON.parse(hole.updates);
        if (club === null || (holeNo !== '' && (hole === null || (!this.props.params.holeNo.toLowerCase().startsWith('new') && typeof(hole.isFullLoaded) === 'undefined')))) return null;

        let subPage = null;
        switch (this.props.params.subpage) {
            case 'general':
                subPage = <PigeonHoleGeneral club={club} pigeonhole={hole} isNew={this.props.params.holeNo.toLowerCase().startsWith('new')} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>;
                break;
            case 'pigeons':
                subPage = <PigeonHolePigeons club={club} pigeonhole={hole} isNew={this.props.params.holeNo.toLowerCase().startsWith('new')} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>;
                break;
            case 'vaccination':
                subPage = <PigeonHoleVaccination club={club} pigeonhole={hole} isNew={this.props.params.holeNo.toLowerCase().startsWith('new')} editMode={this.props.params.mode === 'edit' || this.props.params.mode === 'create'} ref={instance => {this.subForm = instance;}}/>;
                break;
        }

        const updateReq = this.props.params.holeNo.toLowerCase().startsWith('new') || club === null ? null : club.UpdateRequests.find(req => req.type === 'pigeonhole' && req.key === holeNo) || null;
        const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);

        return (<div>
            <div className="sub-page-title">
                <h2>{holeNo.toLowerCase() === 'new' ? 'Nyt slag' : 'Slag ' + holeNo + ' - ' + (hole === null || typeof(hole.Slagnavn) === 'undefined' ? '' : hole.Slagnavn)} ({'Forening ' + clubNo + ', ' + club.Navn})</h2>
            </div>
            <div className="sub-page-content">
                <div className="tab-list">
                    <Link className={(this.props.params.subpage === 'general' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + (hasCommonProps(updates, generalProps) ? ' has-updates' : '')} to={this.props.params.mode === 'view' ? ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(":holeNo", holeNo).replace(":subpage", "general").replace(":mode", "view") : ''}>
                        <span className="tab-text">Generelt</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'pigeons' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + (hasCommonProps(updates, generalProps) ? ' has-updates' : '')} to={this.props.params.mode === 'view' ? ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(":holeNo", holeNo).replace(":subpage", "pigeons").replace(":mode", "view") : ''}>
                        <span className="tab-text">Duebestand</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'vaccination' ? "tab-link active" : "tab-link" + (this.props.params.mode === 'view' ? '' : ' disabled')) + (hasCommonProps(updates, generalProps) ? ' has-updates' : '')} to={this.props.params.mode === 'view' ? ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(":holeNo", holeNo).replace(":subpage", "vaccination").replace(":mode", "view") : ''}>
                        <span className="tab-text">Vaccination</span>
                    </Link>
                </div>
                <div className="tab-page">
                    {subPage}
                </div>
            </div>
            <div className="sub-page-actions">
                {this.props.params.mode === 'view' ? [
                    <span className="left-buttons" key="left">
                        {this.props.params.subpage === 'general' ? <button className="btn-primary" title="Rediger slag" disabled={this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id && (this.props.auth.currentRole !== UserRoles.CLUB_ADMIN.id || this.props.auth.currentEntity !== clubNo)} onClick = {() => {
                            this.props.dispatch(replace(ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', this.props.params.holeNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'edit')));
                        }}>Rediger</button> : null}
                    </span>,
                    <span className="right-buttons" key="right">
                        <Link className="btn-primary" to={ROUTE_CLUB.replace(':clubNo', clubNo).replace(":subpage", "pigeon-holes").replace(":mode", "view")} title={"Vis forening " + clubNo}>
                            Forening {clubNo}
                        </Link>
                        <Link className="btn-primary" to={ROUTE_CLUBS} title="Vis alle foreninger">
                            Foreninger
                        </Link>
                    </span>
                ] : [
                    <span className="left-buttons" key="left">
                        <button className="btn-primary" title="Gem ændringer" onClick = {() => {
                            this.subForm.getWrappedInstance().save((clubNo, holeNo) => {
                                NotificationManager.success(this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? (this.props.params.holeNo.toLowerCase() === 'new' ? "Slaget er oprettet" : "Slaget er opdateret.") : (this.props.params.holeNo.toLowerCase() === 'new' ? "Nyt slag" : "Ændringer") + " er lagt til godkendelse.", this.props.params.holeNo.toLowerCase() === 'new' ? "Oprettelse" : "Opdatering", 4000);
                                const holeNo1 = this.props.params.holeNo.toLowerCase().startsWith('new') ? this.props.params.holeNo.substring(3) : this.props.params.holeNo;
                                const holeNo2 = holeNo.toLowerCase().startsWith('new') ? holeNo.substring(3) : holeNo;
                                const holeUrl = this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? holeNo2 : (this.props.params.holeNo.toLowerCase().startsWith('new') ? (holeNo.toLowerCase().startsWith('new') ? holeNo : 'new' + holeNo) : holeNo1);
                                this.props.dispatch(replace(ROUTE_PIGEON_HOLE.replace(":clubNo", clubNo).replace(':holeNo', holeUrl).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                            })
                        }}>Gem</button>
                    </span>,
                    <span className="right-buttons" key="right">
                        <button className="btn-secondary" title="Annuller ændringer" onClick = {() => {
                            if (holeNo === '') this.props.dispatch(replace(ROUTE_CLUB.replace(':clubNo', clubNo).replace(':subpage', 'pigeon-holes').replace(':mode', 'view')));
                            else this.props.dispatch(replace(ROUTE_PIGEON_HOLE.replace(':clubNo', clubNo).replace(':holeNo', this.props.params.holeNo).replace(':subpage', this.props.params.subpage).replace(':mode', 'view')));
                        }}>Annuller</button>
                    </span>,
                ]}
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => ({
    auth: {
        isMainAdmin: state.auth.isMainAdmin,
        isSectionAdmin: state.auth.isSectionAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        clubs: state.admin.clubs,
        members: state.admin.members,
        pigeonHoles: state.admin.pigeonHoles,
    }
});

export default connect(mapStateToProps)(PigeonHolePage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/club/PigeonHolePage.js